import Vue from 'vue'

// axios
import axios from 'axios'
import enhanceError from "axios/lib/core/enhanceError";
import clearUserData from "@/helpers/Utils";
import router from "@/router/index"

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_AGS_API,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})
axiosIns.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers['Content-Type'] = 'application/json';
  return config;
});

axiosIns.interceptors.response.use(function(response){
  // Any status code that lie within the range of 2xx cause this function to trigger
  const {data: {rsp}} = response;
  if (rsp.code !== 0 && rsp.msg !== 'OK') {
    const vm = new Vue()
    vm.$bvToast.toast(`Error [${rsp.code}]: ${rsp.msg}`, {
      title: 'Error!',
      autoHideDelay: 3000,
      appendToast: false,
      variant: 'danger',
    })
    const error = new Error(rsp.msg)

    if( rsp.code === 11 || rsp.msg === 'Invalid Token' ) {
      router.push('Login')
      clearUserData();
    }

    return Promise.reject( enhanceError(error, response.config, response.status, response.request, response));
  }
  return response;
}, function(error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  const vm = new Vue()
  const {status, statusText, data: {rsp}} = error.response;
  vm.$bvToast.toast(`Error [${rsp?.code ?? status}]: ${rsp?.msg ?? statusText}`, {
    title: `Error [${status}]: ${statusText}`,
    autoHideDelay: 3000,
    appendToast: false,
    variant: 'danger',
  })
  return Promise.reject(error);
});


Vue.prototype.$http = axiosIns

export default axiosIns
